export default __webpack_public_path__ + "static/friends-fe3e6566b68662d8c3e990fdb848c6c2.jpg";